import { gql } from '@apollo/client';

export const GET_INCIDENT_DETAIL_ATTACHMENTS = gql`
  query GET_INCIDENT_DETAIL_ATTACHMENTS($incidentId: ID!, $originatorId: ID!) {
    initialCallInfo(incidentId: $incidentId, originatorId: $originatorId) {
      id
      incidentDetail {
        genericAttachments {
          attachmentType {
            id
            name
            oriId
            position
          }
          incident {
            id
            ori {
              id
            }
          }
          confidential
          dataUrl
          dataUrlWrapper
          description
          id
          dataFileName
          lastUpdated
          ownerName
          employee {
            id
          }
        }
        id
      }
    } 
  } 
`;  
